import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
    request => {
        request.headers['Authorization'] = `Bearer ${localStorage.getItem('merchant-portal-token')}`;
        request.headers['Content-Type'] = 'application/json';
        return request
    },
    error => {
        console.log(error);
    }
)

const storeRefreshedToken = (response) => {
    if (response && response.headers && response.headers['x-refresh-token']) {
        localStorage.setItem('merchant-portal-token', response.headers['x-refresh-token']);
    }
}

axiosInstance.interceptors.response.use(function (response) {
    storeRefreshedToken(response);
    return response;
}, function (error) {
    storeRefreshedToken(error.response);
    return Promise.reject(error);
});

export default axiosInstance;